import {
    ADMIN_PATHS,
    ORGANIZATION_PATHS, PAY_PATHS,
    PUBLIC_PATHS,
    REPORT_PROCEEDING_PATHS, SUPER_ADMIN_PATHS,
    USER_PATHS
} from './config.js';
import React, { lazy } from 'react';
import {Dashboard} from "./Common/Views/Dashboard";
// import {LoginQR} from "./Public/Views/LoginQR";
import {Profile} from "./Common/Views/Profile";
// import { LoginRoten } from './Public/Views/LoginRoten.js';
import { ListNotifications } from './Common/Views/UserNotifications.js';
import { ReportProceeding } from "./Reimbursement/Views/ReportProceeding";
import LogOut from "./Auth/Components/Nav/LogOut";
import ReportProceedingList from "./Reimbursement/Views/ReportProceedingList";
import ReportProceedingInfo from "./Reimbursement/Views/ReportProceedingInfo";
import { Pay } from "./PayReceive/Views/Pay";
import { AdminHonorariumCreate } from "./Honorarium/Views/AdminHonorariumCreate";
import AdminHonorariumList from "./Honorarium/Views/AdminHonorariumList";
import AdminHonorariumInfo from "./Honorarium/Views/AdminHonorariumInfo";
import {Organization} from "./Org/Views/Organization";
import {OrgUsers} from "./Org/Views/OrgUsers";
import {OrgUsersInfo} from "./Org/Views/OrgUsersInfo";
import {AdminUsers} from "./User/Views/AdminUsers";
import {AdminOrganization} from "./Org/Views/AdminOrganization";
import {AdminUserInfo} from "./User/Views/AdminUserInfo";
import {AdminOrganizationInfo} from "./Org/Views/AdminOrganizationInfo";
import {AdminRole} from "./Role/Views/AdminRole";
import AdminExportSIE from './ExportSie/Views/AdminExportSIE.js';
import {DigitalAccount} from "./DigitalAccount/Views/DigitalAccount";
import {AdminAttestListPending} from "./Attest/Views/AdminAttestListPending";
import {AdminAttestInfo} from "./Attest/Views/AdminAttestInfo";
import {AccountRowInfo} from "./DigitalAccount/Views/AccountRowInfo";
import {AdminDigitalAccountList} from "./DigitalAccount/Views/AdminDigitalAccountList";
import {AdminDigitalAccountView} from "./DigitalAccount/Views/AdminDigitalAccountView";
import {AdminAccountRowInfo} from "./DigitalAccount/Views/AdminAccountRowInfo";
import {PendingBankTransferList} from "./BankTransfers/Views/PendingBankTransferList";
import {BankTransferHistoryList} from "./BankTransfers/Views/BankTransferHistoryList";
import {PayInfo} from "./PayReceive/Views/PayInfo";
import {AdminInternalTransactionsCreate} from "./InternalTransaction/Views/AdminInternalTransactionsCreate";
// import CheckoutPage from './SwedBank/Views/SwedBankPayment.js';
// import CheckoutPaymentCompleted from './SwedBank/Views/SwedBankPaymentCompleted.js';
// import CheckoutPaymentCanceled from './SwedBank/Views/SwedBankPaymentAbortedByCustomer.js';
// import CheckoutOpenPaymentCompleted from './BankTransfers/Views/OpenPaymentCompleted.js';
import { SwedbankPay } from './SwedBank/Views/SwedBankPay.js';
import { SwedBankPayInfo } from './SwedBank/Views/SwedBankPayInfo.js';
// import { LoginWithRotenFromLRF } from './Auth/Components/RotenLogin/LoginWithRotenFromLRF.js';
import AdminSalarySheet from './SalarySheet/Views/AdminSalarySheets.js';
import SalarySheet from './SalarySheet/Views/SalarySheet.js';
import AdminReportTaxAuthority from './ReportTaxAuthority/Views/AdminReportTaxAuthority.js';
import {InvoiceList} from "./Invoice/Views/InvoiceList";
import {InvoiceCreate} from "./Invoice/Views/InvoiceCreate";
import {QRCodeList} from "./QR-codes/Views/QRCodeList";
import {QRCodeCreate} from "./QR-codes/Views/QRCodeCreate";
import {QRCodeInfo} from "./QR-codes/Views/QRCodeInfo";
// import {QRCodePublicInfo} from "./QR-codes/Views/QRCodePublicInfo";
// import OrgQrPayment from "./SwedBank/Views/OrgQrPayment";
import {InvoiceCreditCreate} from "./Invoice/Views/InvoiceCreditCreate";
// import CheckoutCompleted from './SwedBank/Views/SwedBankComplete.js';
import { AdminInvoiceList } from './Invoice/Views/AdminInvoiceList.js';
import SuperAdminTransactionList from "./OpenPayment/Views/SuperAdminTransactionList";
// import RedirectView from './Common/Views/Redirect.js';
import { PendingBankTransferInfo } from './BankTransfers/Components/PendingBankTransferListInfo.js';
import { OrgAttestList } from './Attest/Views/OrgAttestList.js';
import { OrgAttestInfo } from './Attest/Views/OrgAttestInfo.js';
import { AdminAttestListHistory } from "./Attest/Views/AdminAttestListHistory";
import { AdminAttestListPendingPrimary } from "./Attest/Views/AdminAttestListPendingPrimary";
import { AdminReportTaxAuthorityInfo } from './ReportTaxAuthority/AdminReportTaxAuthorityInfo.js';
// import LoginWithEntraID from './Auth/Components/EntraID/LoginWithEntraID..js';
import {ReportProceedingV2} from "./Reimbursement/Views/ReportProceedingV2";
import AdminEconomicReport from './EconomicReport/Views/AdminEconomicReport.js';
import AdminHonorariumListHistory from './Honorarium/Views/AdminHonorariumListHistory.js';
import AdminHonorariumUpdate from './Honorarium/Views/AdminHonorariumUpdate.js';
import AdminEconomicReportInfo from './EconomicReport/Views/AdminEconomicReportInfo.js';
import { UserSetting } from './UserSettings/Views/UserSetting.js';
import OrganizationEconomicReport from './EconomicReport/Views/OrganizationEconomicReport.js';
import OrganizationEconomicReportInfo from './EconomicReport/Views/OrganizationEconomicReportInfo.js';
// import { TestErrorPageWithBoundary } from './Common/Components/TestErrorPageWithBoundary.js';
import AdminCostBearerUpdate from './CostBearer/Views/AdminCostBearerUpdate.js';
import AdminCostBearerCreate from './CostBearer/Views/AdminCostBearerCreate.js';
import AdminAccountingCreate from './Accounting/Views/AdminAccountingCreate.js';
import AdminAccountingUpdate from './Accounting/Views/AdminAccountingUpdate.js';
import AdminApiKeyList from './ApiKey/Views/AdminApiKeyList.js';
import { AdminSwedBankReport } from './SwedBank/Views/SwedBankReport.js';
import { SwedBankPayReportInfo } from './SwedBank/Views/SwedbankPayReportInfo.js';
import AdminGuideList from './Guide/Views/AdminGuideList.js';
import AdminGuideUpdate from './Guide/Views/AdminGuideUpdate.js';
import { AdminHonorariumForm } from './Honorarium/Views/AdminHonorariumForm.js';
import AdminCalendarActivityList from './CalendarActivity/Views/AdminCalendarActivityList.js';
import AdminCalendarActivityInfo from './CalendarActivity/Views/AdminCalendarActivityInfo.js';
import AdminGuideListOneTime from './Guide/Views/AdminGuideList-OneTime.js';
import AdminSystemSettings from './SystemSettings/Views/AdminSystemSettings.js';

const LoginQR = lazy(() => 
    import('./Public/Views/LoginQR')
        .then(module => ({ default: module.LoginQR }))
);

const LoginRoten = lazy(() => 
    import('./Public/Views/LoginRoten.js')
        .then(module => ({ default: module.LoginRoten }))
);

const LoginWithRotenFromLRF = lazy(() => 
    import('./Auth/Components/RotenLogin/LoginWithRotenFromLRF.js')
        .then(module => ({ default: module.LoginWithRotenFromLRF }))
);

const CheckoutPage = lazy(() => 
    import('./SwedBank/Views/SwedBankPayment.js')
);

const CheckoutPaymentCompleted = lazy(() => 
    import('./SwedBank/Views/SwedBankPaymentCompleted.js')
);

const CheckoutPaymentCanceled = lazy(() => 
    import('./SwedBank/Views/SwedBankPaymentAbortedByCustomer.js')
);

const CheckoutOpenPaymentCompleted = lazy(() => 
    import('./BankTransfers/Views/OpenPaymentCompleted.js')
);

const QRCodePublicInfo = lazy(() => 
    import('./QR-codes/Views/QRCodePublicInfo')
        .then(module => ({ default: module.QRCodePublicInfo }))
); 

const OrgQrPayment = lazy(() => 
    import('./SwedBank/Views/OrgQrPayment')
);

const CheckoutCompleted = lazy(() => 
    import('./SwedBank/Views/SwedBankComplete.js')
);

const RedirectView = lazy(() => 
    import('./Common/Views/Redirect.js')
);

const LoginWithEntraID = lazy(() => 
    import('./Auth/Components/EntraID/LoginWithEntraID..js')
        .then(module => ({ default: module.LoginWithEntraID }))
);

const TestErrorPageWithBoundary = lazy(() => 
    import('./Common/Components/TestErrorPageWithBoundary.js')
        .then(module => ({ default: module.TestErrorPageWithBoundary }))
);



/*************************************************** PUBLIC *****************************************************/
// PUBLIC ROUTES
export const publicRoutes = [
    {
        path: PUBLIC_PATHS.APP,
        description: 'Inloggningssida via QR-kod',
        component: <LoginQR />
    },
    {
        path: PUBLIC_PATHS.LOGINQR,
        description: 'Inloggningssida via QR-kod',
        component: <LoginQR />
    },
    {
        path: PUBLIC_PATHS.LOGINROTEN,
        description: 'Inloggningssida via Roten SSO',
        component: <LoginRoten />
    },
    {
        path: PUBLIC_PATHS.LOGINROTENFROMLRF,
        description: 'Inloggning via LRF Roten SSO-omdirigering',
        component: <LoginWithRotenFromLRF />
    },
    {
        path: PUBLIC_PATHS.SWEDBANK,
        description: 'Swedbank betalningssida (checkout)',
        component: <CheckoutPage />
    },
    {
        path: PUBLIC_PATHS.SWEDBANKPAYMENTCOMPLETED,
        description: 'Bekräftelsesida efter genomförd Swedbank-betalning',
        component: <CheckoutCompleted />
    },
    {
        path: PUBLIC_PATHS.SWEDBANKCANCELED,
        description: 'Sida som visas när Swedbank-betalning avbryts av kunden',
        component: <CheckoutPaymentCanceled />
    },
    {
        path: PUBLIC_PATHS.SWEDBANKCOMPLETED,
        description: 'Sida som visas när Swedbank-betalning slutförs',
        component: <CheckoutPaymentCompleted />
    },
    {
        path: PUBLIC_PATHS.OPENPAYMENTCOMPLETED,
        description: 'Bekräftelsesida efter genomförd öppen betalning',
        component: <CheckoutOpenPaymentCompleted />
    },
    {
        path: PUBLIC_PATHS.QR_CODE_PUBLIC_INFO,
        description: 'Publik informationssida för QR-kodsbetalning',
        component: <QRCodePublicInfo />,
        //name: ' QR-code test',
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.QR_PAYMENT,
        description: 'Betalningssida via organisations-QR-kod',
        component: <OrgQrPayment />
    },
    {
        path: PUBLIC_PATHS.REDIRECT_VIEW,
        description: 'Omdirigeringssida',
        component: <RedirectView />
    },
    {
        path: PUBLIC_PATHS.LOGINENTRAID,
        description: 'Inloggningssida via Microsoft Entra ID',
        component: <LoginWithEntraID />
    },
    {
        path: PUBLIC_PATHS.ERROR_PAGE,
        description: 'Felsida med error boundary',
        component: <TestErrorPageWithBoundary />
    },

];
/*************************************************** PUBLIC *****************************************************/

/*************************************************** ADMIN *****************************************************/
// GLOBAL ADMIN
/*export const adminGlobalRoutes = [
    {
        dropdown: true,
        title: 'adminLabel.admin',
        name: 'adminLabel.admin',
        icon: 'bx bx-face',
        subs: [
            { path: ADMIN_PATHS.ADMIN_USER, label: 'modelLabel.user' },
            { path: ADMIN_PATHS.ADMIN_ORGANIZATION, label: 'modelLabel.org' },
            { path: ADMIN_PATHS.ADMIN_ROLE, label: 'role.roles' },
            { path: ADMIN_PATHS.HONORARIUM_LIST, label: 'honorarium.honorarium' },
            { path: ADMIN_PATHS.EXPORT_SIE_DATA, label: 'exportSieFile.label' },
            { path: ADMIN_PATHS.ATTEST_LIST, label: 'attest.attest' },
            { path: ADMIN_PATHS.DIGITAL_ACCOUNT_LIST, label: 'digitalAccount.label' },
            { path: ADMIN_PATHS.BANK_TRANSFERS_LIST, label: 'openPayment.bankTransfers' },
            { path: ADMIN_PATHS.INTERNAL_TRANSACTION, label: 'internalTransaction.internalTransaction' },
        ],
    }
]*/

// ADMIN ATTEST NORMAL
export const adminAttestRoutes = [
    {
        path: ADMIN_PATHS.ATTEST_LIST_PENDING,
        description: 'Lista över väntande attestärenden',
        title: 'adminLabel.admin',
        icon: 'bx bxs-calendar-check',
        name: 'sidebar.attest',
        component: <AdminAttestListPending />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_LIST_PENDING_PRIMARY,
        description: 'Lista över väntande attestärenden med primära kostnadsställen',
        component: <AdminAttestListPendingPrimary />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_INFO,
        description: 'Detaljvy för ett attestärende',
        component: <AdminAttestInfo />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_LIST_HISTORY,
        description: 'Historik över attesterade ärenden',
        component: <AdminAttestListHistory />,
        hideInMenu: true,
    }
];
// ADMIN ATTEST WITH PRIMARY COST PLACES
export const adminAttestRoutesPrimary = [
    {
        path: ADMIN_PATHS.ATTEST_LIST_PENDING_PRIMARY,
        description: 'Lista över väntande attestärenden med primära kostnadsställen',
        title: 'adminLabel.admin',
        icon: 'bx bxs-calendar-check',
        name: 'sidebar.attest',
        component: <AdminAttestListPendingPrimary />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_LIST_PENDING,
        description: 'Lista över väntande attestärenden',
        component: <AdminAttestListPending />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_INFO,
        description: 'Detaljvy för ett attestärende',
        component: <AdminAttestInfo />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ATTEST_LIST_HISTORY,
        description: 'Historik över attesterade ärenden',
        component: <AdminAttestListHistory />,
        hideInMenu: true,
    }
];

//ADMIN INVOICE
export const adminInvoiceRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_INVOICE_LIST,
        description: 'Adminvy för lista över skickade fakturor',
        name: 'sidebar.sentInvoices',
        icon: 'bx bxs-file-blank',
        component: <AdminInvoiceList />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_INVOICE_CREDIT,
        description: 'Skapa kreditfaktura (admin)',
        component: <InvoiceCreditCreate />,
        hideInMenu: true,
    },
];

// ADMIN DIGITAL ACCOUNT
export const adminDigitalAccountRoutes = [
    {
        path: ADMIN_PATHS.DIGITAL_ACCOUNT_LIST,
        description: 'Adminvy för lista över alla digitala konton',
        name: 'sidebar.allAccount',
        icon: 'bx bxs-id-card',
        component: <AdminDigitalAccountList />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.DIGITAL_ACCOUNT_VIEW,
        description: 'Detaljvy för ett digitalt konto (admin)',
        component: <AdminDigitalAccountView />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ACCOUNT_ROW_INFO,
        description: 'Detaljvy för en kontorad (admin)',
        component: <AdminAccountRowInfo />,
        hideInMenu: true,
    }
];

// ADMIN HONORARIUM
export const adminHonorariumViewRoutes = [
    {
        path: ADMIN_PATHS.HONORARIUM_LIST,
        description: 'Lista över honorar (admin)',
        name: 'sidebar.honorarium',
        icon: 'bx bxs-file',
        component: <AdminHonorariumList />,
        // hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.HONORARIUM_INFO,
        description: 'Detaljvy för ett honorar',
        component: <AdminHonorariumInfo />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.HONORARIUM_HISTORY_LIST,
        description: 'Historik över honorar',
        component: <AdminHonorariumListHistory />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.HONORARIUM_UPDATE,
        description: 'Uppdatera ett honorar',
        component: <AdminHonorariumForm />,
        hideInMenu: true,
    },
];

// ADMIN CALENDAR ACTIVITY
export const adminCalendarActivityRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_CALENDAR_ACTIVITY_LIST,
        name: 'modelLabel.activityCalendarTitle',
        icon: 'bx bxs-calendar',
        component: <AdminCalendarActivityList />,
    },
    {
        path: ADMIN_PATHS.ADMIN_CALENDAR_ACTIVITY_INFO,
        component: <AdminCalendarActivityInfo />,
        hideInMenu: true,
    }
];

export const adminHonorariumCreateRoutes = [
    {
        path: ADMIN_PATHS.HONORARIUM,
        description: 'Skapa ett nytt honorar',
        component: <AdminHonorariumForm />,
        name: 'sidebar.honorarium',
        icon: 'bx bxs-file',
        // hideInMenu: true,
    }
];


// ADMIN ORG
export const adminOrgViewRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_ORGANIZATION,
        description: 'Adminvy för lista över organisationer',
        name: 'sidebar.org',
        icon: 'bx bxs-building',
        component: <AdminOrganization />,
        // hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_ORGANIZATION_INFO,
        description: 'Detaljvy för en organisation (admin)',
        component: <AdminOrganizationInfo />,
        hideInMenu: true,
    },
];

// ADMIN ROLE
export const adminRoleRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_ROLE,
        description: 'Hantering av roller och behörigheter',
        name: 'sidebar.roles',
        icon: 'bx bxs-group',
        component: <AdminRole />,
        hideInMenu: true,
    }
];

// ADMIN COSTBEARER
export const adminCostBearerRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_COST_BEARER,
        description: 'Lista över kostnadsställen',
        name: 'sidebar.costBearer',
        icon: 'bx bx-briefcase',
        component: <AdminSystemSettings />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_COST_BEARER_UPDATE,
        description: 'Uppdatera ett kostnadsställe',
        component: <AdminCostBearerUpdate />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_CREATE_COST_BEARER,
        description: 'Skapa ett nytt kostnadsställe',
        component: <AdminCostBearerCreate />,
        hideInMenu: true,
    }
];

export const adminGuideListRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_GUIDE_LIST,
        description: 'Lista över guider',
        component: <AdminGuideList />,
        hideInMenu: true,
    },
    /*{
        path: ADMIN_PATHS.ADMIN_GUIDE_LIST_ONE_TIME,
        component: <AdminGuideListOneTime />,
    },*/
    {
        path: ADMIN_PATHS.ADMIN_GUIDE_LIST_UPDATE,
        description: 'Uppdatera en guide',
        component: <AdminGuideUpdate />,
        hideInMenu: true,
    }
];

// ADMIN ACCOUNTING
export const adminAccountingRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_ACCOUNTING_LIST,
        description: 'Lista över kontoinställningar',
        name: 'sidebar.accountingList',
        icon: 'bx bx-book-open',
        component: <AdminSystemSettings />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_ACCOUNTING_UPDATE,
        description: 'Uppdatera en kontoinställning',
        component: <AdminAccountingUpdate />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_ACCOUNTING_CREATE,
        description: 'Skapa en ny kontoinställning',
        component: <AdminAccountingCreate />,
        hideInMenu: true,
    }
];

// ADMIN API KEY
export const adminApiKeyRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_API_KEY,
        description: 'Hantera API-nycklar för externa system',
        name: 'sidebar.apiKey',
        icon: 'bx bx-key',
        component: <AdminApiKeyList />,
        hideInMenu: true,
    },
];

// ADMIN USER
export const adminUserRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_USER,
        description: 'Adminvy för lista över användare',
        name: 'sidebar.user',
        icon: 'bx bxs-user',
        component: <AdminUsers />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_USER_INFO,
        description: 'Detaljvy för en användare (admin)',
        component: <AdminUserInfo />,
        hideInMenu: true,
    }
];

//SETTINGS
export const settingsRoutes = [
    {
        dropdown: true,
        name: 'sidebar.settings',
        icon: 'bx bx-cog',
        subs: [
        ],
    }
]

// ADMIN economic
export const adminEconomicRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_ECONOMIC,
        description: 'Inställningar för ekonomiska värden (admin)',
        component: <AdminSystemSettings />,
        hideInMenu: true,
    }
];

// ADMIN invoice accounts / VAT (tab of the economic settings view)
export const adminInvoiceAccountsRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_INVOICE_ACCOUNTS,
        description: 'Fakturakonton och moms (admin)',
        component: <AdminSystemSettings />,
        hideInMenu: true,
    }
];

// ADMIN economic report
export const adminEconomicReportRoutes = [
    {
        subs: [
            { path: ADMIN_PATHS.ADMIN_ECONOMIC_REPORT, label: 'sidebar.economicReport' },
        ],
    },
    {
        path: ADMIN_PATHS.ADMIN_ECONOMIC_REPORT,
        description: 'Ekonomisk rapport (admin)',
        component: <AdminEconomicReport />,
        hideInMenu: true,

    }
];

export const adminEconomicReportInfoRoutes = [
    {
        path: ADMIN_PATHS.ADMIN_ECONOMIC_REPORT_INFO,
        description: 'Detaljvy för ekonomisk rapport (admin)',
        component: <AdminEconomicReportInfo />,
        hideInMenu: true,

    }
];

// ADMIN SALARY SHEET
export const adminSalaraySheetRoutes = [
    {
        subs: [
            { path: ADMIN_PATHS.SALARY_SHEET, label: 'sidebar.salarySheet' },
        ],
    },
    {
        path: ADMIN_PATHS.SALARY_SHEET,
        description: 'Löneunderlag (admin)',
        component: <AdminSalarySheet />,
        hideInMenu: true,

    }
];

export const adminReportTaxtAuthorityRoutes = [
    {
        subs: [
            { path: ADMIN_PATHS.ADMIN_REPORT_TAX, label: 'modelLabel.taxAuthority' },
        ],
    },
    {
        path: ADMIN_PATHS.ADMIN_REPORT_TAX,
        description: 'AGI-rapportering till Skatteverket',
        name: 'modelLabel.taxAuthority',
        //icon:'bx bx-task',
        component: <AdminReportTaxAuthority />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.ADMIN_REPORT_TAX_INFO,
        description: 'Detaljvy för AGI-rapport till Skatteverket',
        component: <AdminReportTaxAuthorityInfo />,
        hideInMenu: true,
    }
];

// ADMIN SWEDBANK REPORT
export const adminSwedBankReportRoutes = [
    {
        subs: [
            { path: ADMIN_PATHS.ADMIN_SWEDBANK_REPORT, label: 'sidebar.swedbankReport' },
        ],
    },
    {
        path: ADMIN_PATHS.ADMIN_SWEDBANK_REPORT,
        description: 'Swedbank-rapport (admin)',
        name: 'sidebar.swedbankReport',
        icon: 'bx bxs-building',
        component: <AdminSwedBankReport />,
        hideInMenu: true,
    },
    {
        path: PAY_PATHS.SWEDBANKPAY_REPORT_INFO,
        description: 'Detaljvy för Swedbank snabbbetalningsrapport',
        component: <SwedBankPayReportInfo />,
        hideInMenu: true,
    }
];

///REPORTS
export const reportsRoutes = [
    {
        dropdown: true,
        // title: 'Collect',
        name: 'sidebar.reports',
        icon: 'bx bx-download',
        subs: [
        ],
    }
]

// ADMIN SIE
export const adminSieRoutes = [
    {
        subs: [
            { path: ADMIN_PATHS.EXPORT_SIE_DATA, label: 'sidebar.exportSie' },
        ],
    },

    {
        path: ADMIN_PATHS.EXPORT_SIE_DATA,
        description: 'Export av SIE-filer för bokföring',
        name: 'sidebar.exportSie',
        // icon:'bx bx-download',
        component: <AdminExportSIE />,
        hideInMenu: true,
    }
];

// ADMIN TRANSFER
export const adminTransferRoutes = [
    {
        path: ADMIN_PATHS.BANK_TRANSFERS_LIST,
        description: 'Lista över väntande banköverföringar',
        name: 'sidebar.bankTransfers',
        icon: 'bx bx-transfer',
        component: <PendingBankTransferList />,
        //hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.BANK_TRANSFERS_HISTORY_LIST,
        description: 'Historik över banköverföringar',
        component: <BankTransferHistoryList />,
        hideInMenu: true,
    },
    {
        path: ADMIN_PATHS.BANK_TRANSFERS_INFO,
        description: 'Detaljvy för en banköverföring',
        component: <PendingBankTransferInfo />,
        hideInMenu: true,
    },
]

// INTERNAL TRANSACTION
export const adminInternalTransactionRoutes = [
    {
        path: ADMIN_PATHS.INTERNAL_TRANSACTION,
        description: 'Skapa intern transaktion mellan konton',
        name: 'sidebar.internalTransaction',
        icon: 'bx bxs-building-house',
        component: <AdminInternalTransactionsCreate />,
        //hideInMenu: true,
    }
];
/*************************************************** ADMIN *****************************************************/


/*************************************************** FOR YOUR ORGANIZATION *****************************************************/
// DIGITAL ACCOUNT
export const digitalAccountRoutes = [
    {
        path: ORGANIZATION_PATHS.DIGITAL_ACCOUNT,
        description: 'Digitalt konto för organisationen',
        component: <DigitalAccount />,
        name: 'digitalAccount.label',
        icon: 'bx bx-id-card',
    },
    {
        path: ORGANIZATION_PATHS.ACCOUNT_ROW_INFO,
        description: 'Detaljvy för en kontorad',
        component: <AccountRowInfo />,
        name: 'sidebar.digitalAccount',
        hideInMenu: true,
    },
];

export const digitalAccossuntRoutes = [
    {
        path: ORGANIZATION_PATHS.DIGITAL_ACCOUNT,
        description: 'Digitalt konto för organisationen',
        component: <DigitalAccount />,
        name: 'digitalAccount.label',
        icon: 'bx bx-id-card',
    },
    {
        path: ORGANIZATION_PATHS.ACCOUNT_ROW_INFO,
        description: 'Detaljvy för en kontorad',
        component: <AccountRowInfo />,
        name: 'sidebar.digitalAccount',
        hideInMenu: true,
    },
];

// PAY
export const payRoutes = [
    /* {
         dropdown: true,
         title: 'payReceive.payReceiveTitle',
         name: 'payReceive.payReceive',
         icon: 'bx bx-money',
         subs: [
             { path: PAY_PATHS.PAY, label: 'payReceive.pay' },
             { path: PAY_PATHS.SWEDBANKPAY, label: 'payReceive.quickPayment' },
         ],
     },*/
    {
        path: PAY_PATHS.PAY,
        description: 'Betala faktura',
        name: 'sidebar.payInvoice',
        component: <Pay />,
        icon: 'bx bx-money',
        // hideInMenu: true,
    },
    {
        path: PAY_PATHS.PAY_INFO,
        description: 'Detaljvy för en betalning',
        component: <PayInfo />,
        hideInMenu: true,
    },
    {
        path: PAY_PATHS.SWEDBANKPAY,
        description: 'Snabbbetalningar via Swedbank Pay',
        component: <SwedbankPay />,
        hideInMenu: true,
    },
    {
        path: PAY_PATHS.SWEDBANKPAY_INFO,
        description: 'Detaljvy för en Swedbank snabbbetalning',
        component: <SwedBankPayInfo />,
        hideInMenu: true,
    }
];

//COLLECT
export const collectRoutes = [
    {
        dropdown: true,
        // title: 'Collect',
        name: 'sidebar.collect',
        icon: 'bx bx-dollar-circle',
        subs: [
        ],
    }
]

//QR-CODE
export const QRcodeView = [
    {
        subs: [
            { path: ORGANIZATION_PATHS.QR_CODE_LIST, label: 'sidebar.QRcode' },
        ],
    },
    {
        path: ORGANIZATION_PATHS.QR_CODE_LIST,
        description: 'Lista över QR-koder för organisationen',
        component: <QRCodeList />,
        //icon: 'bx bx-qr',
        hideInMenu: true,
    },
    {
        path: ORGANIZATION_PATHS.QR_CODE_INFO,
        description: 'Detaljvy för en QR-kod',
        component: <QRCodeInfo />,
        hideInMenu: true,
    },
]

export const QRcodeCreate = [
    {
        path: ORGANIZATION_PATHS.QR_CODE_CREATE,
        description: 'Skapa en ny QR-kod',
        component: <QRCodeCreate />,
        hideInMenu: true,
    },
]

// QUICKPAYMENT
export const quickPaymentRoutes = [
    /* {
         dropdown: true,
         title: 'payReceive.payReceiveTitle',
         name: 'payReceive.payReceive',
         icon: 'bx bx-money',
         subs: [
             { path: PAY_PATHS.PAY, label: 'payReceive.pay' },
             { path: PAY_PATHS.SWEDBANKPAY, label: 'payReceive.quickPayment' },
         ],
     },*/
    {
        subs: [
            { path: PAY_PATHS.SWEDBANKPAY, label: 'sidebar.quickPayments' },
        ],
    },
    {
        path: PAY_PATHS.PAY_INFO,
        description: 'Detaljvy för en betalning',
        component: <PayInfo />,
        hideInMenu: true,
    },
    {
        path: PAY_PATHS.SWEDBANKPAY,
        description: 'Snabbbetalningar via Swedbank Pay',
        name: 'sidebar.quickPayments',
        component: <SwedbankPay />,
        //icon: 'bx bx-dollar-circle',
        hideInMenu: true,
    },
    {
        path: PAY_PATHS.SWEDBANKPAY_INFO,
        description: 'Detaljvy för en Swedbank snabbbetalning',
        component: <SwedBankPayInfo />,
        hideInMenu: true,
    }
];

// ORG
export const orgRoutes = [
    {
        path: ORGANIZATION_PATHS.ORG_USERS,
        description: 'Lista över användare i organisationen',
        component: <OrgUsers />,
        name: 'sidebar.orgUsers',
        icon: 'bx bx-user',
    },
    {
        path: ORGANIZATION_PATHS.ORG_USERS_INFO,
        description: 'Detaljvy för en användare i organisationen',
        component: <OrgUsersInfo />,
        hideInMenu: true,
    }
];

export const orgDetailsRoutes = [
    {
        path: ORGANIZATION_PATHS.ORGANIZATION,
        description: 'Organisationsinformation och inställningar',
        component: <Organization />,
        name: 'sidebar.orgDetails',
        icon: 'bx bxs-school',
    }
];

export const organizationEconomicReportInfoRoutes = [
    {
        path: ORGANIZATION_PATHS.ORGANIZATION_ECONOMIC_REPORT,
        description: 'Ekonomisk rapport för organisationen',
        component: <OrganizationEconomicReport />,
        name: 'sidebar.economicReport',
        icon: 'bx bx-bar-chart',
    },
    {
        path: ORGANIZATION_PATHS.ORGANIZATION_ECONOMIC_REPORT_INFO,
        description: 'Detaljvy för organisationens ekonomiska rapport',
        component: <OrganizationEconomicReportInfo />,
        hideInMenu: true,
    }
];

// REIMBURSEMENT
/*export const orgSalarySheet = [
    {
        path: ORGANIZATION_PATHS.ORG_SALARY_SHEET,
        component: <OrgSalarySheet/>,
        name: 'modelLabel.salarySheet',
        icon: 'bx bx-wallet'
    }
];*/

//INVOICE
export const invoiceCreate = [
    {
        path: ORGANIZATION_PATHS.INVOICE_CREATE,
        description: 'Skapa en ny faktura',
        component: <InvoiceCreate />,
        hideInMenu: true,
        //name: 'invoice.invoice',
        //icon: 'bx bx-file-blank',
    },
    {
        path: ORGANIZATION_PATHS.INVOICE_CREDIT_CREATE,
        description: 'Skapa en kreditfaktura',
        component: <InvoiceCreditCreate />,
        hideInMenu: true,
        //name: 'invoice.invoice',
        //icon: 'bx bx-file-blank',
    },
];
export const invoiceView = [
    {
        subs: [
            { path: ORGANIZATION_PATHS.INVOICE_LIST, label: 'sidebar.invoice' },
        ],
    },
    {
        path: ORGANIZATION_PATHS.INVOICE_LIST,
        description: 'Lista över fakturor för organisationen',
        component: <InvoiceList />,
        hideInMenu: true,
        //name: 'invoice.invoice',
        //icon: 'bx bx-file-blank',
    }
];

// ORG ATTEST LOCAL GROUP
export const orgAttest = [
    {
        path: ORGANIZATION_PATHS.ORG_ATTEST,
        description: 'Lista över attestärenden för organisationen',
        component: <OrgAttestList />,
        name: 'sidebar.attest',
        icon: 'bx bx-calendar-check',
    },
    {
        path: ORGANIZATION_PATHS.ORG_ATTEST_INFO,
        description: 'Detaljvy för ett attestärende i organisationen',
        component: <OrgAttestInfo />,
        hideInMenu: true,
    }
];


/*************************************************** FOR YOUR ORGANIZATION *****************************************************/


/*************************************************** USER *****************************************************/
// USER
export const userRoutes = [
    {
        path: USER_PATHS.APP,
        description: 'Startsida / Dashboard',
        component: <Dashboard />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.LOGINROTEN,
        description: 'Inloggningssida via Roten SSO',
        component: <LoginRoten />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.LOGINROTENFROMLRF,
        description: 'Inloggning via LRF Roten SSO-omdirigering',
        component: <LoginWithRotenFromLRF />,
        hideInMenu: true,
    },
    {
        path: USER_PATHS.DASHBOARD,
        description: 'Dashboard med översikt och snabbval',
        component: <Dashboard />,
        hideInMenu: true,
    },
    {
        path: USER_PATHS.PROFILE,
        description: 'Användarprofil och personliga uppgifter',
        component: <Profile />,
        hideInMenu: true,
    },
    {
        path: USER_PATHS.NOTIFICATIONS,
        description: 'Lista över användarens notifikationer',
        component: <ListNotifications />,
        hideInMenu: true
    },
    {
        path: USER_PATHS.LOGOUT,
        description: 'Utloggningssida',
        component: <LogOut />,
        hideInMenu: true
    },
    // {
    //     path: USER_PATHS.SETTINGS,
    //     component: <Settings/>,
    //     hideInMenu: true,
    // },
    {
        path: USER_PATHS.SETTINGS,
        description: 'Användarinställningar',
        component: <UserSetting />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.SWEDBANK,
        description: 'Swedbank betalningssida (checkout)',
        component: <CheckoutPage />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.SWEDBANKCANCELED,
        description: 'Sida som visas när Swedbank-betalning avbryts av kunden',
        component: <CheckoutPaymentCanceled />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.SWEDBANKCOMPLETED,
        description: 'Sida som visas när Swedbank-betalning slutförs',
        component: <CheckoutPaymentCompleted />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.OPENPAYMENTCOMPLETED,
        description: 'Bekräftelsesida efter genomförd öppen betalning',
        component: <CheckoutOpenPaymentCompleted />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.QR_CODE_PUBLIC_INFO,
        description: 'Publik informationssida för QR-kodsbetalning',
        component: <QRCodePublicInfo />,
        //name: ' QR-code test',
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.QR_PAYMENT,
        description: 'Betalningssida via organisations-QR-kod',
        component: <OrgQrPayment />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.REDIRECT_VIEW,
        description: 'Omdirigeringssida',
        component: <RedirectView />,
        hideInMenu: true,
    },
    {
        path: PUBLIC_PATHS.ERROR_PAGE,
        description: 'Felsida med error boundary',
        component: <TestErrorPageWithBoundary />,
        hideInMenu: true,
    }
];

// REIMBURSEMENT
export const reimbursementCreateRoutes = [
    {
        path: REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING,
        description: 'Skapa ett nytt ersättningsärende',
        component: <ReportProceedingV2 />,
        name: 'sidebar.reimbursement',
        icon: 'bx bx-receipt'
    }
];
export const reimbursementViewRoutes = [
    {
        path: REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_LIST,
        description: 'Lista över ersättningsärenden',
        component: <ReportProceedingList />,
        name: 'sidebar.reimbursement',
        icon: 'bx bx-receipt',
    },
    {
        path: REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_INFO,
        description: 'Detaljvy för ett ersättningsärende',
        component: <ReportProceedingInfo />,
        hideInMenu: true,
    },
    /*{
        path: REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_V2,
        component: <ReportProceedingV2/>,
        hideInMenu: true,
    }*/
];


export const salarySheet = [
    {
        path: USER_PATHS.SALARY_SHEET,
        description: 'Lönespecifikation för användaren',
        component: <SalarySheet />,
        name: 'sidebar.salarySheet',
        icon: 'bx bx-wallet'
    }
];
/*************************************************** USER *****************************************************/


/*************************************************** SUPER ADMIN *****************************************************/
// SUPER ADMIN
export const transactionRoutes = [
    {
        path: SUPER_ADMIN_PATHS.TRANSACTION,
        description: 'Super admin-vy för lista över öppna betalningstransaktioner',
        component: <SuperAdminTransactionList />,
        title: 'adminLabel.systemAdmin',
        name: 'sidebar.OPtransaction',
        icon: 'bx bx-transfer'
    }
];
/*************************************************** SUPER ADMIN *****************************************************/